/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */


document.addEventListener('DOMContentLoaded', function() {
fetch('/browsing_context_suggestions.json')
  .then(response => response.json())
  .then(data => {
    const countryCode = data?.detected_values?.country?.handle; // Extract the country code
    console.log("you are coming from: ", countryCode);
    if (countryCode === 'DE') {


    } else {
      // User is not from DE
      $(".shipping-bar").hide();
    }
  })
  .catch(error => {
    console.error('Error:', error);
    // Handle error if the request fails
  });
  
});


$(document).ready(function() {
  $('.shopify-product-form button#AddToCart').on('click', function() {
    setTimeout(function() {
      console.log("Button clicked");
      $('#cartlink').attr('aria-expanded', 'true');
      $('#cartlink').trigger('click');
    }, 700);
  });
});




 $(document).ready(function() {
    // Add an id of "faq" to the element with class ".shopify-section--faq"
    $(".shopify-section--faq").attr("id", "faq");

    // Check if #faq is existent on the page
    if ($("#faq").length) {
      // Append the new button after the last "button.tabs-nav__item.heading.heading--small"
      $(".tabs-nav__item-list button.tabs-nav__item.heading.heading--small:last-child")
        .after('<button type="button" class="tabs-nav__item heading heading--small" aria-controls="open-faq">FAQ</button>');

      $(".product-tabs__content .product-tabs__tab-item-wrapper:last-child")
        .after('<button is="toggle-button" class="faqbtn_mobile collapsible-toggle heading heading--small hidden-lap-and-up" >FAQ<svg focusable="false" width="12" height="8" class="icon icon--chevron" viewBox="0 0 12 8"><path fill="none" d="M1 1l5 5 5-5" stroke="currentColor" stroke-width="2"></path></svg></button>');
    }

    // Scroll to the #faq section with a custom offset of -300px when clicking the new button
    $("button[aria-controls='open-faq']").on("click", function() {
      var faqSection = $("#faq");
      if (faqSection.length) {
        $('html, body').animate({
          scrollTop: faqSection.offset().top - 300
        }, 500);
      }
    });

    // Scroll to the #faq section with a custom offset of -300px when clicking the new button
    $(".faqbtn_mobile").on("click", function() {
      var faqSection = $("#faq");
      if (faqSection.length) {
        $('html, body').animate({
          scrollTop: faqSection.offset().top - 300
        }, 500);
      }
    });
  });





/*
// Target element
var banner = $("#banner-wrapper")[0]; // Get the raw DOM element

// Callback function to be executed when changes are detected
var callback = function (mutationsList, observer) {
  for (var mutation of mutationsList) {
    if (mutation.type === 'attributes' &&
        mutation.attributeName === 'style' &&
        banner.style.opacity === "1" &&
        banner.style.visibility === "visible") {
      console.log("Popup appeared");
      observer.disconnect(); // Disconnect the observer once conditions are met
    }
  }
};

// Create a new observer with the callback function
var observer = new MutationObserver(callback);

// Configure the observer to watch for changes in the style attribute
observer.observe(banner, { attributes: true });

// Note: If the popup never appears, make sure to handle the scenario appropriately.
// You may want to set a timeout or handle it based on user interactions.*/



$(document).ready(function () {
  // Your previous code to detect popup appearance using MutationObserver

  // Attach a click event handler to p#all_accept
  $("p#all_accept").on("click", function (event) {
    // Prevent the default click behavior
    event.preventDefault();

    // Perform a click on p#essential_accept
    $("p#essential_accept").click();
    //console.log("delegated to essentials");
  });
});



window.addEventListener('scroll', function () {
  const scrollPosition = window.scrollY;
  const isMobile = window.innerWidth <= 768;
  const scrollThreshold = isMobile ? 80 : 100;
  const header = document.querySelector('.myheader');

  if (!header) return;

  if (scrollPosition > scrollThreshold) {
    header.classList.add('current_sticky');
  } else {
    header.classList.remove('current_sticky');
  }
});

